export default __webpack_public_path__ + "static/media/minisite-pagetype-wishlist.bd57e6e9.svg";